import React, { FC } from 'react';
import { Spin } from 'antd';
import { SpinCont } from './Spinner.styles';

interface ISpinner {
  size?: 'small' | 'default' | 'large';
}

const Spinner: FC<ISpinner> = ({ size = 'default' }) => (
  <SpinCont id="SpinCont" data-testid="spinCont">
    <Spin {...{ size }} />
  </SpinCont>
);

export default Spinner;
